import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=80f76080&scoped=true&"
import script from "./Letter.vue?vue&type=script&lang=js&"
export * from "./Letter.vue?vue&type=script&lang=js&"
import style0 from "./Letter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Letter.vue?vue&type=style&index=1&id=80f76080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f76080",
  null
  
)

export default component.exports